// TODO SZ: remove since is not used in a new design

import { Page } from '@customTypes/page';

import CommonLayout from '@layouts/CommonLayout';

import FaqContent from '@modules/static/components/FaqContent';

import s from '@styles/pages/Static.module.scss';

import cn from 'classnames';

const containerClass = 'container-medium';

const FaqPage: Page = () => (
  <div className={cn(s.root, containerClass)}>
    <FaqContent />
  </div>
);

FaqPage.getLayout = function getLayout(page) {
  return <CommonLayout>{page}</CommonLayout>;
};

export default FaqPage;
